module.exports = __webpack_public_path__ + "static/img/login-m-2.e812073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-m-2.png
// module id = 7in4
// module chunks = 7